import { onUnmounted } from 'vue';

export default function useWindowScroll(onScroll: () => void) {
  const scroll = () => {
    onScroll();
  };
  window.addEventListener('scroll', scroll);
  onUnmounted(() => {
    window.removeEventListener('scroll', scroll);
  });
}
